import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { Employee } from 'src/app/shared/models/employee.model';

@Component({
  selector: 'app-modal-employees',
  templateUrl: './employees-modal.component.html'
})
export class ModalEmployeesComponent implements OnInit {
  @Input() isVisible = false;
  employees$: Observable<Employee[]>;

  constructor(private employeeService: EmployeeService) { }

  ngOnInit() {
  }

  open() {
    this.employees$ = this.employeeService.employees$;
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
  }

}
